module.exports = __webpack_public_path__ + "static/media/heart-icon.5db8f0ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/heart-icon.svg
// module id = 522
// module chunks = 0